/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateTuitionRatePlanResponse
 */
export interface CreateTuitionRatePlanResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateTuitionRatePlanResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateTuitionRatePlanResponse
     */
    name: string;
}

/**
 * Check if a given object implements the CreateTuitionRatePlanResponse interface.
 */
export function instanceOfCreateTuitionRatePlanResponse(value: object): value is CreateTuitionRatePlanResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateTuitionRatePlanResponseFromJSON(json: any): CreateTuitionRatePlanResponse {
    return CreateTuitionRatePlanResponseFromJSONTyped(json, false);
}

export function CreateTuitionRatePlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTuitionRatePlanResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
    };
}

export function CreateTuitionRatePlanResponseToJSON(json: any): CreateTuitionRatePlanResponse {
    return CreateTuitionRatePlanResponseToJSONTyped(json, false);
}

export function CreateTuitionRatePlanResponseToJSONTyped(value?: CreateTuitionRatePlanResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
    };
}

